export const selecteTruthAnswerList = (state) =>
  state.courseTest.truthAnswerList;

export const selecteFalsAnswerList = (state) => state.courseTest.falsAnswerList;

export const selecteShowDetails = (state) => state.courseTest.showDetails;

export const selectedResetQuizGroup = (state) =>
  state.courseTest.resetQuizGroup;

export const selecteQuizTitle = (state) => state.courseTest.quizTitle;
